(function (a, b) {
  if ("function" == typeof define && define.amd) define(["exports", "@babel/runtime/helpers/extends", "@babel/runtime/helpers/objectWithoutProperties", "react", "prop-types", "../hoc/withDeviceSize", "./NavBarItemDesktop", "./NavBarItemTablet"], b);else if ("undefined" != typeof exports) b(exports, require("@babel/runtime/helpers/extends"), require("@babel/runtime/helpers/objectWithoutProperties"), require("react"), require("prop-types"), require("../hoc/withDeviceSize"), require("./NavBarItemDesktop"), require("./NavBarItemTablet"));else {
    var c = {
      exports: {}
    };
    b(c.exports, a._extends, a.objectWithoutProperties, a.react, a.propTypes, a.withDeviceSize, a.NavBarItemDesktop, a.NavBarItemTablet), a.MainMenuItem = c.exports;
  }
})("undefined" == typeof globalThis ? "undefined" == typeof self ? this : self : globalThis, function (a, b, c, d, e, f, g, h) {
  "use strict";

  var i = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = void 0, b = i(b), c = i(c), d = i(d), e = i(e), f = i(f), g = i(g), h = i(h);

  var j = function j(a) {
    var e = a.component,
        f = a.isMobileSized,
        i = a.isPhoneSized,
        j = a.id,
        k = (0, c.default)(a, ["component", "isMobileSized", "isPhoneSized", "id"]);
    var l = f ? h.default : g.default;
    return d.default.createElement(e || l, (0, b.default)({
      key: j,
      id: j
    }, k));
  };

  j.propTypes = {
    component: e.default.func,
    isMobileSized: e.default.bool,
    isPhoneSized: e.default.bool,
    id: e.default.string
  }, j.defaultProps = {
    component: null,
    isMobileSized: !1,
    isPhoneSized: !1,
    id: void 0
  };
  var k = (0, f.default)()(j);
  a.default = k;
});